import {
  TaskCompletedStatus,
  TaskItemStatus,
} from '@r1-development/resolution-mechanicalturk-api-client';
import {
  TaskGroupsApiParamsIntersection,
  TaskTypes,
} from 'src/app/shared/models/tasks.model';

export interface SidebarTaskUi {
  id: string;
  accountNumber: string;
  taskType: TaskTypes;
  title: string;
  subtitle?: string;
  workStatus?: 'in-progress' | 'not-started';
  taskStatus: TaskItemStatus;
  dueDate: string;
  completedById: string;
  completedAt: string;
  oppValue: number;
  taskState?: 'Escalation' | 'Missing docs' | 'Follow-up exhausted';
  routerLinkPath: string[];
  work?: { completedStatus?: TaskCompletedStatus };
  globalEligible?: boolean;
  payerPortal?: string;
  clientName?: string;
}

export interface SidebarTaskGroupUi {
  id: string;
  taskType: TaskTypes;
  tasks: SidebarTaskUi[];
  title: string;
  workStatus?: 'in-progress' | 'not-started';
  completedById: string;
  taskStatus: TaskItemStatus;
  phoneNumber?: string;
  website?: string;
  globalEligible?: boolean;
}

export const enum SidebarTabs {
  OpenTasks = 0,
  CompletedTasks = 1,
}

export enum TaskOwnershipType {
  My = 'my-tasks',
  Unassigned = 'unassigned-tasks',
}
export type TaskOwnership = TaskOwnershipType.My | TaskOwnershipType.Unassigned;

export interface SidebarListsContract<
  T extends TaskGroupsApiParamsIntersection,
> {
  reloadData(params: T): void;
}
